import { useContext } from "react";
import { context } from "../contexts";
import { Navigate } from "react-router-dom";

const ALLOWED_USERS = ['SUPORTE'];

export default function PrivateAdmin({ children }) {
    const { signed, user } = useContext(context);

    if (!signed) {
        return <Navigate to="/" />;
    }

    if (!ALLOWED_USERS.includes(user?.Usuario?.toUpperCase())) {
        return <Navigate to="/home" />;
    }

    return children;
}
